//Used in tracker data input to lazy load large dataset to improve load time
(function (app, ng) {
    app.directive("infiniteScroll", ["$document", function ($document) {
        return function (scope, elm, attr) {
            var raw = elm[0];
            console.log('hit');
            elm.bind('scroll', function () {
                if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight - 550) {
                    scope.$apply(attr.infiniteScroll);
                }
            });
        };
    }]);

})(window.app, window.angular);